let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cw6fr")).then(() => parcelRequire('k11bO'));